import { isMouseEvent } from "../../../base/browser/dom";
import { IMouseEvent, StandardMouseEvent } from "../../../base/browser/mouseEvent";
import { Emitter, Event } from "../../../base/common/events";
import { Disposable, DisposableStore, toDisposable } from "../../../base/common/lifecycle";
import { IWindowsMainService } from "../../windows/common/windows";
import { IPointerService } from "../common/pointer";



export class BrowserPointerService extends Disposable implements IPointerService {
    _serviceBrand: undefined;


    private readonly _onMouseDown = this._register(new Emitter<IMouseEvent>());
    readonly onMouseDown = this._onMouseDown.event;

    private readonly _onMouseMove = this._register(new Emitter<IMouseEvent>());
    readonly onMouseMove = this._onMouseMove.event;

    private readonly _onMouseUp = this._register(new Emitter<IMouseEvent>());
    readonly onMouseUp = this._onMouseUp.event;

    private readonly _onMouseCancel = this._register(new Emitter<IMouseEvent>());
    readonly onMouseCancel = this._onMouseCancel.event;

    constructor(
        @IWindowsMainService windowsMainService: IWindowsMainService
    ) {
        super();

        const mainWindow = globalThis.window;
        this.subscribeToWindowEvents(mainWindow);

        this._register(windowsMainService.onDidOpenWindow((evt) => {
            const window = evt.getWindow();
            this.subscribeToWindowEvents(window);
        }));
        this._register(windowsMainService.onDidDestroyWindow((evt) => {
            const window = evt.getWindow();
            if (window === this.currentWindow) {
                this.subscribeToWindowEvents(mainWindow);
            }
        }));
    }

    private disposeEvents: DisposableStore | null = null;
    private currentWindow: Window | null = null;

    subscribeToWindowEvents(window: Window): void {
        this.disposeEvents?.dispose();
        this.disposeEvents = new DisposableStore();
        this.currentWindow = window;

        window.addEventListener('pointerdown', this.onPointerDownEvent);
        this.disposeEvents.add(toDisposable(() => {
            window.removeEventListener('pointerdown', this.onPointerDownEvent);
        }));
        window.addEventListener('pointermove', this.onPointerMoveEvent);
        this.disposeEvents.add(toDisposable(() => {
            window.removeEventListener('pointermove', this.onPointerMoveEvent);
        }));
        window.addEventListener('pointerup', this.onPointerUpEvent);
        this.disposeEvents.add(toDisposable(() => {
            window.removeEventListener('pointerup', this.onPointerUpEvent);
        }));
        window.addEventListener('pointercancel', this.onPointerCancelEvent);
        this.disposeEvents.add(toDisposable(() => {
            window.removeEventListener('pointercancel', this.onPointerCancelEvent);
        }));
    }

    private onPointerDownEvent = (event: PointerEvent) => {
        if (isMouseEvent(event)) {
            const mouseEvent = new StandardMouseEvent(this.currentWindow!, event);
            this._onMouseDown.fire(mouseEvent);
        }
    }
    private onPointerMoveEvent = (event: PointerEvent) => {
        if (isMouseEvent(event)) {
            const mouseEvent = new StandardMouseEvent(this.currentWindow!, event);
            this._onMouseMove.fire(mouseEvent);
        }
    }
    private onPointerUpEvent = (event: PointerEvent) => {
        if (isMouseEvent(event)) {
            const mouseEvent = new StandardMouseEvent(this.currentWindow!, event);
            this._onMouseUp.fire(mouseEvent);
        }
    }
    private onPointerCancelEvent = (event: PointerEvent) => {
        if (isMouseEvent(event)) {
            const mouseEvent = new StandardMouseEvent(this.currentWindow!, event);
            this._onMouseCancel.fire(mouseEvent);
        }
    }
}